<script setup>
import {ref} from "vue";
import {onClickHashLink} from "../../../Helpers/helper";

const roadmapSwiper = ref(null);
const roadmapHeadSwiper = ref(null);

const setRoadmapSwiper = (swiper) => {
    roadmapSwiper.value = swiper;
};

const setRoadmapHeadSwiper = (swiper) => {
    roadmapHeadSwiper.value = swiper;
};

const onSlideChange = (s) => {
    s.slides.forEach((slide, index) => {
        if (s.activeIndex === index) {
            slide.classList.add('active');
        } else {
            slide.classList.remove('active');
        }
    })
}

const onHeadSlideClick = (ev) => {
    const slide = ev.target.closest('.swiper-slide');
    if (slide) {
        const clickedIndex = [].indexOf.call(slide.parentNode.children, slide);
        roadmapSwiper.value.slideTo(clickedIndex);
        roadmapHeadSwiper.value.slides.forEach((slide, index) => {
            if (clickedIndex === index) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }
        });
    }
}

const playerList = [
    'Состояния',
    'Спутники',
    'Автолевелап',
    'Ролл дайсов',
    'Гильдии',
    'Передача предметов',
    '<strike>Крысиные</strike> заявки',
    'Боёвки',
];

const masterList = [
    'Календарь игр',
    'Подготовка к&nbsp;играм',
    'Гильдмастер',
    'Игровые сессии',
    'Инициатива',
    'NPC',
    'Интерактивные карты',
    'Логи',
]

</script>

<template>
    <section id="features" class="group section-screen mt-4 md:pt-8 md:mt-24 lg:pt-16 lg:mt-0 xl:mt-24 pb-4 lg:pb-8 relative">
        <div class="max-w-full w-[1536px] mx-auto px-6 relative">
            <div class="screen-dice-wrapper relative text-center mb-14 lg:absolute lg:block lg:w-[27%] xl:w-[36%] lg:right-0 lg:top-1/2 lg:-translate-y-1/2">
                <svg width="465" height="280" viewBox="34 52 130 80" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-4 inline-block max-w-full" style="transform: rotateZ(10deg) translate(10%,10%);">
                    <rect x="35.2104" y="52.8306" width="80.4248" height="80.4248" rx="1.35702" fill="#111111"/>
                    <path d="M60.2542 89.4811C58.0124 89.4811 55.8306 89.1409 53.7089 88.4603C51.6006 87.7798 49.8125 86.799 48.3447 85.518L52.0876 79.5532C52.6348 80.1937 53.3687 80.7542 54.2894 81.2346C55.2101 81.7149 56.1976 82.0886 57.2518 82.3554C58.3059 82.6223 59.3067 82.7558 60.2542 82.7558C61.3217 82.7558 62.2024 82.6023 62.8963 82.2954C63.5902 81.9885 63.9371 81.5548 63.9371 80.9944C63.9371 80.4473 63.6702 80.0002 63.1365 79.6533C62.6027 79.293 61.6153 78.926 60.1741 78.5524L58.0924 77.992C55.05 77.1646 52.8749 76.0171 51.5672 74.5492C50.2595 73.068 49.6057 71.32 49.6057 69.305C49.6057 68.0374 49.8792 66.8564 50.4263 65.7622C50.9868 64.668 51.7607 63.7139 52.7482 62.8999C53.749 62.0726 54.9232 61.4321 56.271 60.9784C57.6187 60.5247 59.0799 60.2978 60.6545 60.2978C62.923 60.2978 65.0313 60.6314 66.9795 61.2986C68.9411 61.9525 70.5023 62.8599 71.6633 64.0208L67.7802 69.8254C67.3131 69.2783 66.7127 68.798 65.9787 68.3843C65.2448 67.9573 64.4375 67.6237 63.5568 67.3835C62.6761 67.1433 61.7887 67.0232 60.8947 67.0232C60.1874 67.0232 59.5736 67.1099 59.0532 67.2834C58.5328 67.4435 58.1258 67.6704 57.8322 67.964C57.552 68.2442 57.4119 68.5711 57.4119 68.9447C57.4119 69.2783 57.532 69.5519 57.7722 69.7654C58.0124 69.9789 58.406 70.1857 58.9531 70.3859C59.5136 70.5861 60.2675 70.8262 61.2149 71.1065L63.2566 71.707C66.299 72.601 68.4874 73.7019 69.8218 75.0096C71.1562 76.3173 71.8234 78.0053 71.8234 80.0736C71.8234 81.9284 71.343 83.5631 70.3822 84.9775C69.4215 86.392 68.0737 87.4996 66.339 88.3002C64.6043 89.0875 62.576 89.4811 60.2542 89.4811Z" fill="white"/>
                    <path d="M89.2176 89.4811C87.0292 89.4811 85.0142 89.1142 83.1728 88.3803C81.3313 87.633 79.73 86.5988 78.3689 85.2778C77.0212 83.9567 75.9737 82.4088 75.2264 80.6341C74.4925 78.8593 74.1255 76.9378 74.1255 74.8695C74.1255 72.7878 74.4925 70.8596 75.2264 69.0849C75.9737 67.3101 77.0212 65.7622 78.3689 64.4412C79.73 63.1201 81.3313 62.0926 83.1728 61.3587C85.0142 60.6248 87.0292 60.2578 89.2176 60.2578C91.406 60.2578 93.4143 60.6314 95.2424 61.3787C97.0839 62.126 98.6785 63.1668 100.026 64.5012C101.387 65.8356 102.441 67.3902 103.189 69.1649C103.936 70.9263 104.31 72.8278 104.31 74.8695C104.31 76.9378 103.936 78.8593 103.189 80.6341C102.441 82.4088 101.387 83.9567 100.026 85.2778C98.6785 86.5988 97.0839 87.633 95.2424 88.3803C93.4143 89.1142 91.406 89.4811 89.2176 89.4811ZM89.2176 81.9151C90.1917 81.9151 91.0791 81.755 91.8797 81.4347C92.6937 81.1011 93.3943 80.6274 93.9814 80.0136C94.5685 79.3998 95.0222 78.6592 95.3425 77.7918C95.6627 76.9244 95.8229 75.9503 95.8229 74.8695C95.8229 73.4283 95.5426 72.1807 94.9822 71.1265C94.4217 70.0723 93.6411 69.2583 92.6403 68.6845C91.6529 68.1107 90.512 67.8239 89.2176 67.8239C88.2435 67.8239 87.3494 67.9907 86.5355 68.3243C85.7348 68.6445 85.0409 69.1115 84.4538 69.7254C83.8667 70.3392 83.413 71.0798 83.0927 71.9471C82.7725 72.8145 82.6123 73.7886 82.6123 74.8695C82.6123 76.3106 82.8925 77.5583 83.453 78.6125C84.0134 79.6666 84.7874 80.4806 85.7748 81.0544C86.7756 81.6282 87.9232 81.9151 89.2176 81.9151Z" fill="white"/>
                    <path d="M60.386 125.442C58.1976 125.442 56.1826 125.075 54.3412 124.341C52.4997 123.594 50.8984 122.56 49.5373 121.239C48.1896 119.918 47.1421 118.37 46.3948 116.595C45.6609 114.82 45.2939 112.899 45.2939 110.83C45.2939 108.749 45.6609 106.821 46.3948 105.046C47.1421 103.271 48.1896 101.723 49.5373 100.402C50.8984 99.081 52.4997 98.0535 54.3412 97.3196C56.1826 96.5857 58.1976 96.2187 60.386 96.2187C62.5744 96.2187 64.5827 96.5923 66.4108 97.3396C68.2523 98.0869 69.8469 99.1277 71.1946 100.462C72.5557 101.797 73.6099 103.351 74.3571 105.126C75.1044 106.887 75.478 108.789 75.478 110.83C75.478 112.899 75.1044 114.82 74.3571 116.595C73.6099 118.37 72.5557 119.918 71.1946 121.239C69.8469 122.56 68.2523 123.594 66.4108 124.341C64.5827 125.075 62.5744 125.442 60.386 125.442ZM60.386 117.876C61.3601 117.876 62.2475 117.716 63.0481 117.396C63.8621 117.062 64.5627 116.588 65.1498 115.974C65.7369 115.361 66.1906 114.62 66.5109 113.753C66.8311 112.885 66.9913 111.911 66.9913 110.83C66.9913 109.389 66.711 108.142 66.1506 107.087C65.5901 106.033 64.8095 105.219 63.8087 104.645C62.8213 104.072 61.6804 103.785 60.386 103.785C59.4119 103.785 58.5178 103.952 57.7039 104.285C56.9032 104.605 56.2093 105.072 55.6222 105.686C55.0351 106.3 54.5814 107.041 54.2611 107.908C53.9408 108.775 53.7807 109.75 53.7807 110.83C53.7807 112.272 54.0609 113.519 54.6214 114.573C55.1818 115.628 55.9558 116.442 56.9432 117.015C57.944 117.589 59.0916 117.876 60.386 117.876Z" fill="white"/>
                    <path d="M79.8931 124.842V96.8192H87.9796L97.7874 111.871V96.8192H105.594V124.842H97.5072L87.6994 109.549V124.842H79.8931Z" fill="white"/>
                    <rect x="106.596" y="123.723" width="13.5702" height="80.7905" rx="6.78508" transform="rotate(-135 106.596 123.723)" fill="url(#paint0_linear_19_172)"/>
                    <rect x="94.5923" y="137.199" width="13.5702" height="13.5932" rx="6.78508" transform="rotate(-135 94.5923 137.199)" fill="url(#paint1_linear_19_172)"/>
                    <defs>
                        <linearGradient id="paint0_linear_19_172" x1="113.381" y1="123.723" x2="113.381" y2="204.514" gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#FFA500"/>
                            <stop offset="1" stop-color="#FF6B00"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_19_172" x1="101.377" y1="137.199" x2="101.377" y2="150.792" gradientUnits="userSpaceOnUse">
                            <stop offset="0" stop-color="#FFA500"/>
                            <stop offset="1" stop-color="#FF6B00"/>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div class="text-xs md:text-md lg:text-lg mb-1 md:mb-3 text-red">&mdash;&nbsp;твоя идея может быть тут</div>
            <div class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none text-black dark:text-white">Появится<br>в&nbsp;будущем</div>
            <div class="mt-8 lg:mt-12 leading-10 flex justify-between lg:max-w-[66%] xl:max-w-[53%]">
                <div class="md:w-[36.5%]">
                    <div class="text-xl md:text-2xl font-bold leading-none tracking-tighter text-black dark:text-white">Игрокам</div>
                    <ul class="text-sm md:text-md lg:text-lg mt-3 lg:mt-7 list-disc leading-[2em] lg:leading-8 pl-3 md:pl-6 pr-3">
                        <li v-for="item in playerList" v-html="item"></li>
                    </ul>
                </div>
                <div class="md:w-[36.5%]">
                    <div class="text-xl md:text-2xl font-bold leading-none tracking-tighter text-black dark:text-white">Мастеру</div>
                    <ul class="text-sm md:text-md lg:text-lg mt-3 lg:mt-7 list-disc leading-[2em] lg:leading-8 pl-3 md:pl-6">
                        <li v-for="item in masterList" v-html="item"></li>
                    </ul>
                </div>
            </div>
            <a href="/#subscribe" class="btn mt-8 md:mt-16 text-red" @click="onClickHashLink">
                <span class="btn-text">Это мы ждём</span>
                <span class="btn-hover-wrapper">
                    <span class="btn-hover">
                        <span>Это мы ждём</span>
                    </span>
                </span>
            </a>
        </div>
    </section>
</template>

<style lang="scss">
    #features .screen-dice {
        &.d4 {
            @apply hidden;
        }

        &.d6 {
            @apply hidden;
        }

        &.d8 {
            @apply hidden;
        }

        &.d10 {
            @apply top-[75%] left-[75%] lg:top-[105%] lg:left-[0%];
        }

        &.d20 {
            @apply bottom-[60%] -left-[5%] lg:bottom-[55%] lg:left-[50%];
        }
    }
</style>
